<div class="card-deal-container">
  <p>DEAL #: {{ _rushGameService.dealNo }}</p>

  <div class="fit-content relative">
    <app-mode-tag
      class="center"
      *ngIf="showModeTag"
      [label]="mode.name"
      [cssClass]="mode.class"
    ></app-mode-tag>
    <div class="cards" [class.!border-white]="isDealOpen" *ngIf="dealCardsLength > 0; else noCards">
      <div [class.card-down-animation]="dealCards.first" id="firstCard">
        <div [class.open-card]="dealCards.first">
          <svg-icon svgClass="w-full h-full" [src]="buildUrl(dealCards.first)"></svg-icon>
        </div>
      </div>
      <div [class.card-down-animation]="dealCards.second" id="secondCard" class="card-down-animation">
        <div [class.open-card]="dealCards.second">
          <svg-icon svgClass="w-full h-full" [src]="buildUrl(dealCards.second)"></svg-icon>
        </div>
      </div>
      <div [class.card-down-animation]="dealCards.maverick" id="maverickCard" class="card-down-animation">
        <div [class.maverick-card]="dealCards.maverick">
          <svg-icon svgClass="w-full h-full" [src]="buildUrl(dealCards.maverick)"></svg-icon>
        </div>
      </div>
    </div>
    <ng-template #noCards>
      <div class="cards" [class.!border-white]="isDealOpen"></div>
    </ng-template>
  </div>
</div>
